module.exports = __webpack_public_path__ + "static/media/DevicePage.08834061.zip";